export default __webpack_public_path__ + "static/media/Dominando Banco de Dados CERT.62be82c5.png";